export default __webpack_public_path__ + "static/media/LottieLoading.a6747be3.gif";